import _ from 'lodash'

import { searchUtils } from '../../utils'
import { searchAPI } from '../../api'
import { types as filtersTypes } from './filters.module'


const DEFAULT_STATE = {
  activeStepIdx: 0,
  steps: {
    data: null,
    isFetching: true
  },
  originalStepsData: null
}

// Actions
export const types = {
  SET_ACTIVE_STEP: 'gulftree/guided-search/SET_ACTIVE_STEP',
  SET_STEP_DIRTY: 'gulftree/guided-search/SET_STEP_DIRTY',
  UPDATE_QUESTION_ANSWERS: 'gulftree/guided-search/UPDATE_QUESTION_ANSWERS',
  RESET_ALL_STEPS: 'gulftree/guided-search/RESET_ALL_STEPS',
  SET_STEPS_DATA: 'gulftree/guided-search/SET_STEPS_DATA',
  SET_STEPS_DATA_IS_FETCHING: 'gulftree/guided-search/SET_STEPS_DATA_IS_FETCHING',
}

// Reducer
export default function reducer(state = DEFAULT_STATE, action = {}) {
  switch (action.type) {

    case types.SET_ACTIVE_STEP:
      return {
        ...state,
        activeStepIdx: action.payload
      }

    case types.SET_STEP_DIRTY: {
      // Find the step set as dirty and update its isDirty value
      const updatedSteps = state.steps.data.map((step, idx) => ({
        ...step,
        isDirty: action.payload === idx || step.isDirty
      }))

      return {
        ...state,
        steps: {
          ...state.steps,
          data: updatedSteps
        }
      }
    }

    case types.UPDATE_QUESTION_ANSWERS: {
      const { activeStepIdx } = action.payload

      // Update active step's dirty state (for things ling enabled submit button)
      const updatedStepsData = state.steps.data.map((step, idx) => {
        return idx === activeStepIdx ? { ...step, hasAnsweredQuestions: true } : step
      })

      return {
        ...state,
        steps: {
          ...state.steps,
          data: updatedStepsData
        }
      }
    }

    case types.RESET_ALL_STEPS:
      return {
        ...state,
        activeStepIdx: 0,
        steps: {
          ...state.steps,
          data: _.cloneDeep(state.originalStepsData)
        }
      }

    case types.SET_STEPS_DATA:
      return {
        ...state,
        steps: {
          ...state.steps,
          data: action.payload
        },
        originalStepsData: action.payload
      }

    case types.SET_STEPS_DATA_IS_FETCHING:
      return {
        ...state,
        steps: {
          ...state.steps,
          isFetching: action.payload
        }
      }

    default:
      return state;
  }
}

// Action Creators
export function setActiveStep(idx) {
  return {
    type: types.SET_ACTIVE_STEP,
    payload: idx
  }
}

export function setDirtyStep(idx) {
  return {
    type: types.SET_STEP_DIRTY,
    payload: idx
  }
}

export function onUpdateStep() {
  return (dispatch, getState) => {
    dispatch({
      type: types.UPDATE_QUESTION_ANSWERS,
      payload: { activeStepIdx: getState().guidedSearch.activeStepIdx }
    })
  }
}

export function resetAllSteps() {
  return { type: types.RESET_ALL_STEPS }
}

export function fetchSteps() {
  return (dispatch, getState) => {
    dispatch({ type: types.SET_STEPS_DATA_IS_FETCHING, payload: true })

    searchAPI.getGuidedSearchSteps()
      .then(res => {
        // Set steps data
        dispatch({ type: types.SET_STEPS_DATA, payload: searchUtils.prepGuidedSearchSteps(res) })
        dispatch({ type: types.SET_STEPS_DATA_IS_FETCHING, payload: false })

        // Set blacklist filter IDs (IDs that are supposed to be ignored in search)
        const currentBlacklistIds = getState().filters.filterIdsBlacklist
        const newBlacklistIds = _.flatMap(res, step => {
          const termsToIgnore = step.filter.filter_terms.filter(term => _.get(term.meta, ['ignore']))
          return termsToIgnore.map(term => term.id)
        })
        const ids = _.uniq([...currentBlacklistIds, ...newBlacklistIds])

        dispatch({ type: filtersTypes.UPDATE_ID_BLACKLIST, payload: ids })
      })
  }
}
